import React from "react";

export default function LoadingSpinner() {

  return <i className='bx bx-loader-alt bx-spin bx-flip-vertical'></i>

}